import { Config } from '../../config'

export const airmasterConfig: Config = {
  partner: 'airmaster',
  catalog: 'partner',
  displayName: 'AMS',
  accentColor: '#2d5c88',
  host: 'chairs.airmastersystems.com',
  extraAttributes: {
  }
}
